/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  Grid,
  Row,
  Col,
  Panel,
  Collapse,
} from 'react-bootstrap';
import SelectPills from 'loracoms/SelectPills';
import PageLoading from 'loracoms/PageLoading';
import PageNoPerm from 'loracoms/PageNoPerm';
import PageError from 'loracoms/PageError';
import adrActions from 'loraactions/adr';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ErrorSet from 'lorautils/errors/ErrorSet';
import styles from './styles.scss';

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  getAdr: React.PropTypes.func.isRequired,
  adr: React.PropTypes.object.isRequired,
  basic: React.PropTypes.object.isRequired,
  applyAdr: React.PropTypes.func.isRequired,
  unapplyAdr: React.PropTypes.func.isRequired,
  apply: React.PropTypes.object.isRequired,
  unapply: React.PropTypes.object.isRequired,
};

class ADRView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      basic: props.basic,
      adr: props.adr,
      errors: new ErrorSet(),
    };
    this.handleToggleAdr = this.handleToggleAdr.bind(this);
    this.intlMsg = new IntlMsg(props.intl, 'network.adrview');
  }

  componentWillMount() {
    const { getAdr } = this.props;
    getAdr();
  }

  componentWillReceiveProps(nextProps) {
    const { basic, adr, apply, unapply, getAdr } = nextProps;
    if (basic !== this.props.basic) {
      this.setState({ basic });
    }
    if (adr !== this.props.adr) {
      this.setState({ adr });
    }

    const { errors } = this.state;
    if (apply !== this.props.apply) {
      if (apply.status === 'success' || apply.status === 'failure') {
        getAdr();
      }
      if (apply.status === 'failure') {
        this.setState({
          errors: errors.add(apply.error.code, 'switch'),
        });
      } else {
        this.setState({
          errors: errors.remove('switch'),
        });
      }
    }
    if (unapply !== this.props.unapply) {
      if (unapply.status === 'success' || unapply.status === 'failure') {
        getAdr();
      }
      if (unapply.status === 'failure') {
        this.setState({
          errors: errors.add(unapply.error.code, 'switch'),
        });
      } else {
        this.setState({
          errors: errors.remove('switch'),
        });
      }
    }
  }

  handleToggleAdr(selected) {
    const { unapplyAdr, applyAdr } = this.props;
    const enabled = selected === 'on';
    if (enabled) {
      applyAdr();
    } else {
      unapplyAdr();
    }
  }

  renderAdrSwitch() {
    const { adr } = this.state;
    if (adr.status === 'success') {
      const options = [
        { name: this.intlMsg.msg('switch.on'), value: 'on', active: adr.data.enabled },
        { name: this.intlMsg.msg('switch.off'), value: 'off', active: !adr.data.enabled },
      ];
      return (
        <SelectPills
          options={options}
          onChange={selected => this.handleToggleAdr(selected[0])}
        />
      );
    }
    return <i className="fa fa-spinner fa-spin" />;
  }

  renderHelpDoc() {
    const { intl } = this.props;
    if (intl.locale === 'zh') {
      return (
        <div className={styles.helpDoc}>
          <p>
            ADR(自适应数据速率)是一种通过动态调整终端速率和功率来优化网络容量和设备电池寿命的方法。
          </p>
          <p>
            例如，靠近网关的节点会使用一个较高的数据速率（较短的传输时间）和一个较低的输出功率。只有在链路预算
            边缘的节点，才使用最低的数据传输速率和最高的传输功率。
          </p>
          <p>
            ADR可以适应网络架构的变化，支持多变的路径损耗。LoRa网络架构为每个实现了ADR的终端设备管理数据速率
            和RF输出，进而最大化终端设备的电池寿命和总体网络容量。
          </p>
        </div>
      );
    }
    return (
      <div className={styles.helpDoc}>
        <p>
          <strong>A</strong>daptive <strong>D</strong>ata <strong>R</strong>ate
          is a method where the actual data rate is adjusted to ensure reliable
          packet delivery, optimal network performance, and scale for capacity.
        </p>
        <p>
          For example, nodes close to the gateway will use a higher data rate
          (shorter time on air) and a lower output power. Only nodes that are at
          the very edge of the link budget will use the lowest data rate and highest
          output power.
        </p>
        <p>
          The ADR method can accommodate changes in the network
          infrastructure and support varying path loss. To maximize both battery life
          of end‐devices and overall network capacity, the LoRa network infrastructure
          manages the data rate and RF output for each end‐device individually by
          implementing ADR.
        </p>
      </div>
    );
  }

  renderContent() {
    const { errors } = this.state;
    return (
      <Grid fluid>
        <Row>
          <Col md={12}>
            <Panel bsStyle="aisz-white">
              <Row>
                <Col md={12}>
                  <div className={styles.switch}>
                    <span className={styles.label}>ADR</span>
                    {this.renderAdrSwitch()}
                    <span className={styles.errorTips}>
                      <Collapse in={errors.has('switch')} dimension="width">
                        <div>
                          <span className="halflings halflings-alert" />
                          {' '}
                          {this.intlMsg.errorMsg(errors.get('switch'))}
                        </div>
                      </Collapse>
                    </span>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <div className={styles.tips}>
                    {this.intlMsg.msg('tips.title')}
                    <ul>
                      <li><span className="halflings halflings-hand-right" />{' '}{this.intlMsg.msg('tips1')}</li>
                      <li><span className="halflings halflings-hand-right" />{' '}{this.intlMsg.msg('tips2')}</li>
                      <li><span className="halflings halflings-hand-right" />{' '}{this.intlMsg.msg('tips3')}</li>
                    </ul>
                  </div>
                  {this.renderHelpDoc()}
                </Col>
              </Row>
            </Panel>
          </Col>
        </Row>
      </Grid>
    );
  }

  render() {
    const { basic } = this.props;
    if (basic.status === 'success') {
      if (basic.tier === 1) {
        return <PageNoPerm />;
      }
      return this.renderContent();
    }
    if (basic.status === 'request' || basic.status === 'pending') {
      return <PageLoading />;
    }
    return <PageError />;
  }
}

ADRView.propTypes = propTypes;

const mapStateToProps = state => ({
  basic: state.org.basic,
  adr: state.adr.getAdr,
  apply: state.adr.applyAdr,
  unapply: state.adr.unapplyAdr,
});

const mapDispatchToProps = {
  getAdr: adrActions.getAdr,
  applyAdr: adrActions.applyAdr,
  unapplyAdr: adrActions.unapplyAdr,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(ADRView));




// WEBPACK FOOTER //
// ./src/containers/Network/coms/ADRView/index.jsx